var app = angular.module("leonardo");

var WorkFlowDeleteDialog = function($scope, FormErrorsService, WorkFlowService) {
  $scope.workflow = $scope.ngDialogData.workflow;
  $scope.submit = function() {
    $scope.Form.$setSubmitted();
    if ($scope.Form.$invalid) {
      FormErrorsService.goToError();
      return;
    }
    $scope.workflow.remove().then(function() {
      WorkFlowService.updateCollection($scope.workflow, true);
      $scope.confirm();
    });
  };
};

app.controller('WorkFlowDeleteDialog', ['$scope', 'FormErrorsService', 'WorkFlowService', WorkFlowDeleteDialog]);
